import React from "react";

import Listado from "./list";

import { connect } from "react-redux";

import {
    reset,
    clientList as list,
    remove,
    isLoading,
    isLoaded,
    getMeta,
    getList,
    getError,
    isSecondaryLoading,
} from "../../../../../redux/actions/payment/list";

import {
    CACHE_CLIENT,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getClientsById,
} from "../../../../../redux/actions/cache/interface";

import {
    encodeQueryToURL,
    decodeQueryFromURL,
    onTableChangeUpdateUrl,
    onFilterChangeUpdateUrl,
} from "../../../../../core/utils/list";

/**
 * Container:
 *
 *   Se encarga de la conexion entre Redux y el Componente  que presenta los datos
 *
 * De paso en algunos caso, excepto formularios se maneja el Loading y el título.
 *
 * OBS: En formularios es mejor que el 'loading' lo maneje el formulario dado que Formik
 *    si se redibuja pierde los datos, entonces hay que tener cuidado con eso.
 */
class Container extends React.Component {
    constructor(props) {
        super(props);
        const defaultValues = { active: 1 };

        this.state = { defaultValues };
    }

    componentDidMount() {
        const query = decodeQueryFromURL(this.props.history, this.state.defaultValues);

        this.props.loadCache();
        this.props.list(query);
    }

    componentDidUpdate(prevProps) {
        const { history } = this.props;

        if (history.location.search != prevProps.location.search) {
            const query = decodeQueryFromURL(history, this.state.defaultValues);

            this.props.list(query);
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    _onFilterChangeUpdateUrl = (form) => onFilterChangeUpdateUrl(this.props.history, form);
    _onTableChangeUpdateUrl = (pagination, filters, sorter) =>
        onTableChangeUpdateUrl(this.props.history, pagination, filters, sorter);

    render() {
        const parameters = decodeQueryFromURL(this.props.history, this.state.defaultValues);
        return (
            <>
                <Listado
                    {...this.props}
                    filters={parameters}
                    onUpdateFilters={this._onFilterChangeUpdateUrl}
                    handleTableChange={this._onTableChangeUpdateUrl}
                />
            </>
        );
    }
}

const cacheList = [CACHE_CLIENT];

function MapStateToProps(state) {
    return {
        meta: getMeta(state),
        data: getList(state),
        loading: isLoading(state) || isCacheLoading(state, cacheList),
        actionLoading: isSecondaryLoading(state),
        error: getError(state),

        loaded: isLoaded(state) && isCacheLoaded(state, cacheList),
        clientsById: getClientsById(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),
        list: (query) => dispatch(list(query)),
        reset: () => dispatch(reset()),
        remove: (id) => dispatch(remove(id)),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
